import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router} from 'react-router-dom'
import queryString from 'query-string'
import moment from 'moment'

import { PaginationContext } from '../../context/pagination'
import { NextDisabledContext } from '../../context/nextDisabled'

import * as dateFormatting from './date_formatting'
import Coaching1 from './coaching_p1'
import Coaching2 from './coaching_p2'
import CoachingUnavailable from './coaching_unavailable'
import CoachingMatch from './coaching_match'
import FetchWrapper from '../../utils/fetch_wrapper'

import './coaching.css'

import config from '../../utils/config'

class Coaching extends Component {
  constructor(props) {
    super(props)

    this.updateActivePage = this._updateActivePage.bind(this)
    this.nextPage = this._nextPage.bind(this, props.history)
    this.getInspiratorTimes = this._getInspiratorTimes.bind(this) 
    this.addInspiratorHistory = this._addInspiratorHistory.bind(this)
    this.createEvent = this._createEvent.bind(this)
    this.setApiErrorFalse = this._setApiErrorFalse.bind(this)
    this.findSessions = this._findSessions.bind(this)
    this.getEvents = this._getEvents.bind(this)
    this.getInspiratorInfo = this._getInspiratorInfo.bind(this)
    this.getIsJPMCPilot = this._getIsJPMCPilot.bind(this)
    document.title = "Book Coaching Session"

    this.state = {
      apiError: false,
      loading: true,
      nextDisabled: false
    }
  }
  
  static getPageCount() {
    return 3
  }

  _updateActivePage(n) {
    this.context.updateActivePage(this.props.match.path, n)
  }

  async _nextPage(history, cur, state) {
    let isUpdated = false
    const plId = queryString.parse(window.location.search).plId
    if (this.state.nextDisabled) return null
    this.setState({
      nextDisabled: true
    }, async () => {
      switch(cur) {
        case '/1':
          let eventStatus = null
          let inspiratorAssigned = false
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/coaching/1') return null
          let eventDateTime = state.slotTimeSelected.value
          if (eventDateTime) {
            eventStatus = await this.createEvent(history, 'scheduled', 'program_orientation', eventDateTime)
          } else {
            eventStatus = await this.createEvent(history, 'unavailable', 'program_orientation', moment())
          }
  
          if (eventStatus !== 'success') return
  
          if (eventDateTime) {
            inspiratorAssigned =  await this.assignInspirator(history)
          }
          if (inspiratorAssigned) {
            isUpdated = await this.updateStepCompleted(history, 'CoachingBooked1', '/coaching/2')
          } else {
            isUpdated = await this.updateStepCompleted(history, 'BookingUnavailable', '/coaching/unavailable')
          }
          
          if (isUpdated && inspiratorAssigned) {
            await this.props.getStepCompleted(plId)
            return history.push('/2' + history.location.search, history.location.state)
          } else if (isUpdated) {
            await this.props.getStepCompleted(plId)
            return history.push('/unavailable' + history.location.search)
          }
          return ;
        case '/2':
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/coaching/2') return null
          if (state.isSessionConfirmed2 || state.isSessionConfirmed3) {
            isUpdated = await this.updateStepCompleted(history, 'CoachingBooked2', '/coaching/match')
          } else {
            isUpdated = await this.updateStepCompleted(history, 'CoachingBooked1', '/coaching/match')
          }
          if (isUpdated) {
            await this.props.getStepCompleted(plId)
            return history.push('/match' + history.location.search)
          }
          return ;
        case '/match':
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/coaching/match') return null
          isUpdated = await this.updateStepCompleted(history, null, '/profile/1')
          if (isUpdated) {
            return this.props.next()
          }
          return ;
        case '/unavailable':
          await this.props.getStepCompleted(plId)
          if (window.location.pathname !== '/coaching/unavailable') return null
          isUpdated = await this.updateStepCompleted(history, 'BookingUnavailable', '/profile/1') 
          if (isUpdated) {
            return this.props.next()
          }
          return ;
        default:
          return null
      }
    })
  }

  async _createEvent(history, eventStatus, eventType, eventDateTime) {
    const plId = queryString.parse(history.location.search).plId

    if (eventStatus !== 'unavailable') {
      const today = moment()
      if (eventDateTime <= today) {
        alert('The selected session has expired. Please select a different time.')
        this.setState({
          apiError: true,
          nextDisabled: false
        })
        return 'expired'
      }
    }
    eventDateTime = eventDateTime.toISOString()

    const params = {
      plId : parseInt(plId),
      inspiratorId: history.location.state ? history.location.state.inspiratorId : null,
      eventDateTime: eventDateTime,
      eventType: eventType, 
      eventStatus: eventStatus
    }

    try {
      let response = await FetchWrapper.fetch(config.endpoint_createEvent, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if(status !== 'success') {
        alert("This time slot was just booked by another user. Please select a different time.")
        this.setState({
          apiError: true,
          nextDisabled: false
        })
        return false
      }
      return response.status
    } catch(error) {
      alert("This time slot was just booked by another user. Please select a different time.")
      this.setState({
        apiError: true,
        nextDisabled: false
      })
      return false
    }
  }

  async updateStepCompleted(history, stepCompleted, nextStepUrl) {
    const code = queryString.parse(history.location.search)

    nextStepUrl = window.location.origin + nextStepUrl
  
    const params = {
      plId : parseInt(code.plId),
      RegCode: code.regCode,
      NextStepUrl: nextStepUrl,
      StepCompleted: stepCompleted
    }   
    try { 
      let response = await FetchWrapper.fetch(config.endpoint_updateStepCompleted, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if(status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }
      return true
    } catch (error) {
      this.setState({
        nextDisabled: false
      })
      return false 
    }
  }

  async _getInspiratorTimes(history, startDate, rangeInDays) {
    const plId = queryString.parse(history.location.search).plId
    let queryParams = `&rangeStart=${dateFormatting.midnightFormat(startDate)}`
    if (history.location.state && history.location.state.inspiratorId) {
      queryParams += `&inspiratorId=${history.location.state.inspiratorId}`
    } 
    queryParams += `&plId=${parseInt(plId)}`
    if (rangeInDays) {
      queryParams += `&rangeInDays=${rangeInDays}`
    }

    try {
      let response = await FetchWrapper.fetch(config.endpoint_getInspiratorTimes + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      })

      return response
    } catch(error) {
    }
  }

  async _findSessions(history, inspiratorId, session1) {
    try {
      if (!inspiratorId || !session1) {
        throw new Error('missing inspirator or first session')
      }
      const code = queryString.parse(history.location.search)
      let firstSessionDT = session1.toISOString()
      let queryParams = `&plId=${code.plId}&followupSessions=2&inspiratorId=${inspiratorId}&firstSessionDT=${firstSessionDT}`
      let response = await FetchWrapper.fetch(config.endpoint_findSessions + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      })

      return response
    } catch(error) {
    }
  }

  async _getEvents(history) {
    const plId = queryString.parse(history.location.search).plId

    let queryParams = `&plId=${plId}`
    try { 
      let response = await FetchWrapper.fetch(config.endpoint_getEvents + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })

      return response.data.Events
    } catch (error) {
      return null
    }

  }

  async assignInspirator(history) {
    const plId = queryString.parse(history.location.search).plId
    let params = null
    const historyState = history.location.state
    if (historyState && historyState.inspiratorId) {
      params = {
        plId: parseInt(plId),
        inspiratorId: historyState.inspiratorId
      }
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_assignInspirator, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })
      
      return true
    } catch(error) {
      return false
    }
  }

  async _getInspiratorInfo(history) {
    const plId = queryString.parse(history.location.search).plId
    let queryParams = `&plId=${plId}`

    try {
      let response = await FetchWrapper.fetch(config.endpoint_getInspiratorInfo + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      })

      return response.data
    } catch(error) {
      return null
    }
  }

  async _getIsJPMCPilot(history) {
    const plId = queryString.parse(history.location.search).plId
    let queryParams = `&plIdDecoded=${plId}`

    try {
      let response = await FetchWrapper.fetch(config.endpoint_isJPMCPilot + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      })

      return response.data
    } catch(error) {
      return null
    }
  }

  _addInspiratorHistory(history, inspiratorInfo) {
    if (inspiratorInfo) {
      const newHistory = {
        ...history.location.state,
        inspiratorId: inspiratorInfo
      }
      history.replace(history.location.pathname + history.location.search, newHistory)
    } 
  }

  _setApiErrorFalse() {
    this.setState ({
      apiError: false
    })
  }

  async componentDidMount() {
    const plId = queryString.parse(window.location.search).plId
    await this.props.getStepCompleted(plId)
    this.setState({ loading: false })
  }

  componentDidUpdate() {
    if (this.shouldRedirect()) {
      let result = this.props.setShouldRedirect(true)
      if (result) this.setState({ nextDisabled: false })
    } else {
      this.props.setShouldRedirect(false)
    }
  }

  shouldRedirect() {
    if (!this.props.nextStepPath) return true
    const n = this.props.nextStepPath.search('\\?')
    let nextPath = this.props.nextStepPath.substring(0, n)
    if ((nextPath === '/coaching/1' && window.location.pathname === '/coaching/1') || 
        (nextPath === '/coaching/match' && window.location.pathname === '/coaching/match') ||
        (nextPath === '/coaching/2' && window.location.pathname === '/coaching/2') ||
        (nextPath === '/coaching/unavailable' && window.location.pathname === '/coaching/unavailable')) {
      return false
    }
    return true
  }

  extendRoute(R) {
    return props => {
      return <R
        updateActivePage={this.updateActivePage}
        {...props}
        next={this._nextPage.bind(this, props.history)}
        getInspiratorTimes={this.getInspiratorTimes}
        addInspiratorHistory={this.addInspiratorHistory}
        apiError={this.state.apiError}
        setApiErrorFalse={this.setApiErrorFalse.bind(this)}
        findSessions={this.findSessions}
        getEvents={this.getEvents}
        createEvent={this.createEvent}
        getInspiratorInfo={this.getInspiratorInfo}
        getIsJPMCPilot={this.getIsJPMCPilot}
      />
    }
  }

  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="coaching">
        <NextDisabledContext.Provider value={this.state.nextDisabled}>
          <Router basename={this.props.match.path}>
            <Switch>
              <Route exact path="/1" render={this.extendRoute(Coaching1)} />
              <Route exact path="/2" render={this.extendRoute(Coaching2)} />
              <Route exact path="/unavailable" render={this.extendRoute(CoachingUnavailable)} />
              <Route exact path="/match" render={this.extendRoute(CoachingMatch)} />
            </Switch> 
          </Router>
        </NextDisabledContext.Provider>
      </div>
    )
  }
}

Coaching.contextType = PaginationContext

export default Coaching
